import { render } from "./LinkCard.vue?vue&type=template&id=52508004&scoped=true"
import script from "./LinkCard.vue?vue&type=script&lang=js"
export * from "./LinkCard.vue?vue&type=script&lang=js"

import "./LinkCard.vue?vue&type=style&index=0&id=52508004&scoped=true&lang=css"

import exportComponent from "/Users/min/Desktop/lambda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52508004"]])

export default __exports__